import React, { useEffect, useState } from "react"
import Loader from "../ux/loader"

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location)

  setTimeout(() => {
    if (typeof window !== "undefined" && window.globalLenis) {
      window.globalLenis.scrollTo(currentPosition ? currentPosition[1] : 0)
    } else {
      window.scrollTo(...(currentPosition || [0, 0]))
    }
  }, 0)

  return false
}

const RootWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Evita rodar no SSR
    if (typeof window === "undefined" || typeof document === "undefined") return

    const handleLoad = () => {
      setLoading(false)
    }

    if (document.readyState === "complete") {
      setLoading(false)
    } else {
      window.addEventListener("load", handleLoad)
      return () => window.removeEventListener("load", handleLoad)
    }
  }, [])

  return (
    <>
      {loading && <Loader />}
      {children}
    </>
  )
}

export default RootWrapper
